import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
	getAvailablePeriods,
	getRoutes,
	setDeliveryRoutesDate,
} from 'actions/DeliveryRoutes';
import DCSelect from 'containers/DCSelect';
import PeriodSelect from 'containers/PeriodSelect';
import RouteTypeSelect from 'containers/RouteTypeSelect';
import RoutesDateSelect from '../components/RoutesDateSelect';
import RoutesSelect from '../components/RoutesSelect';
import RoutesStatus from '../components/RoutesStatus';
import SelectedRouteContainer from './SelectedRouteContainer';

class RoutesInfoContainer extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		if (!this.props.selectedDate) {
			this.props.setDeliveryRoutesDate();
		} else {
			this.updateRoutesList();
		}
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.distributionCenter !== this.props.distributionCenter ||
			prevProps.selectedDate !== this.props.selectedDate ||
			prevProps.selectedPeriodId !== this.props.selectedPeriodId ||
			prevProps.selectedRouteType !== this.props.selectedRouteType
		) {
			this.updateRoutesList();
		}
	}

	handleSelectDate = date => {
		this.props.setDeliveryRoutesDate(date);
	};

	updateRoutesList = () => {
		this.props.getRoutes(this.props.selectedDate);
	};


	renderLoading() {
		const { routesContainer } = this.props;
		if (routesContainer.loading)
			return (
				<Grid item xs={12}>
					<CircularProgress size={50} />
				</Grid>
			);
		return null;
	}

	renderNoRoutesToday() {
		const { routesContainer, selectedPeriodId } = this.props;
		if (
			!routesContainer.error &&
			!routesContainer.loading &&
			routesContainer.data.length === 0 &&
			selectedPeriodId
		)
			return (
				<Grid item xs={12}>
					Nenhuma rota salva nesta data
				</Grid>
			);
		return null;
	}


	renderDateSelect() {
		return (
			<RoutesDateSelect onSelect={this.handleSelectDate} selectedDate={this.props.selectedDate} />
		);
	}

	renderPeriodSelect() {
		return <PeriodSelect />;
	}

	renderRouteTypeSelect() {
		return <RouteTypeSelect />;
	}

	renderRoutesSelect() {
		const { routesContainer } = this.props;

		if (routesContainer.data && routesContainer.data.length > 0) {
			return <RoutesSelect routes={routesContainer.data} />;
		}
		return null;
	}

	renderRoutesStatus() {
		const { periods, routesContainer, selectedPeriodId, selectedDate } = this.props;

		const hasRoutes =
			routesContainer && routesContainer.data && routesContainer.data.length > 0;
		const hasPeriod = periods && selectedPeriodId;

		if (hasRoutes && hasPeriod) {
			return (
				<RoutesStatus
					routes={routesContainer.data}
					date={selectedDate}
					period={periods.find(period => period.id === selectedPeriodId)}
				/>
			);
		}
		return null;
	}

	render() {
		return (
			<Grid container spacing={24}>
				<Grid item xs={12}>
					<Grid container direction="row" spacing={16}>
						<Grid item xs={3}>
							<DCSelect />
						</Grid>
						<Grid item xs={3}>
							{this.renderDateSelect()}
						</Grid>
						<Grid item xs={3}>
							{this.renderPeriodSelect()}
						</Grid>
						<Grid item xs={3}>
							{this.renderRouteTypeSelect()}
						</Grid>
					</Grid>
					<Grid container direction="row" spacing={16}>
						<Grid item xs={12}>
							{this.renderRoutesStatus()}
						</Grid>
					</Grid>
					<Grid container direction="row" spacing={16}>
						<Grid item xs={2}>
							{this.renderRoutesSelect()}
						</Grid>
						<Grid item xs={10}>
							<SelectedRouteContainer />
						</Grid>
					</Grid>
				</Grid>
				{this.renderLoading()}
				{this.renderNoRoutesToday()}
			</Grid>
		);
	}
}

const mapStateToProps = state => ({
	routesContainer: state.deliveryRoutes.routesContainer,
	periods: state.periods.available,
	selectedPeriodId: state.periods.selected,
	selectedDate: state.deliveryRoutes.selectedDate,
	distributionCenter: state.distributionCenters.selected,
	selectedRouteType: state.routeTypes.selected,
});

RoutesInfoContainer.propTypes = {
	distributionCenter: PropTypes.string,
	selectedDate: PropTypes.string,
	selectedRouteType: PropTypes.string,
	selectedPeriodId: PropTypes.string,
	periods: PropTypes.array,
	routesContainer: PropTypes.shape({
		data: PropTypes.array,
		loading: PropTypes.bool,
		error: PropTypes.string,
	}),
	// Actions
	getRoutes: PropTypes.func.isRequired,
	getAvailablePeriods: PropTypes.func.isRequired,
	setDeliveryRoutesDate: PropTypes.func.isRequired,
};


export default connect(
	mapStateToProps,
	{
		getRoutes,
		getAvailablePeriods,
		setDeliveryRoutesDate,
	}
)(RoutesInfoContainer);
